import React from "react";
import PropTypes from "prop-types";

export default function AlertBanner({
  type = "info",
  title,
  message,
  onClose,
  statusMessage = true,
  dismissible = true,
  confirmOnDismiss = true,
  fadeOutMs = 200,
}) {
  const classesByType = {
    error: "status-error",
    success: "status-success",
    warning: "status-warning",
    info: "status-info",
  };
  const typeClass = classesByType[type] ?? classesByType.info;

  const handleDismiss = () => {
    if (confirmOnDismiss) {
      const ok = window.confirm("Are you sure you want to dismiss this alert?");
      if (!ok) return;
    }
    window.setTimeout(() => {
      onClose?.();
    }, fadeOutMs);
  };

  return (
    <div
      className={[statusMessage ? "status-message " : "payment-grid-card ", "status text-start", typeClass, dismissible ? "status-dismissible" : ""].join(" ")}
      role="alert"
      aria-live="polite"
    >
      {dismissible && <button type="button" className="btn-close" data-dismiss="alert" aria-label="Close" onClick={handleDismiss} />}

      <div className="status-message-icon">
        <i className="icon-alert">
          <span className="sr-text">alert</span>
        </i>
      </div>
      {title && <h2>{title}</h2>}
      {message && <p dangerouslySetInnerHTML={{ __html: message }} />}
    </div>
  );
}

AlertBanner.propTypes = {
  type: PropTypes.oneOf(["error", "success", "warning", "info"]),
  title: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  dismissible: PropTypes.bool,
  confirmOnDismiss: PropTypes.bool,
  fadeOutMs: PropTypes.number,
  statusMessage: PropTypes.bool,
};
